import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { GrantModal } from "./GrantModal";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";
import { useDeleteUserProfileSectionItem } from "Constant/apiHooks";
import { formatMonthYear } from "Utils";

export const Grants = ({ grantList, fetchData, isCurrentUserProfile }) => {
  const { t } = useTranslation();

  const { deleteUserProfileSectionItem } = useDeleteUserProfileSectionItem();

  const [grantModal, setGrantModal] = useState(false);
  const [selectedGrantData, setSelectedGrantData] = useState(null);

  const toggleGrantModal = (grnt) => {
    setGrantModal((prevGrantModalState) => !prevGrantModalState);
    if (grnt) {
      setSelectedGrantData(grnt);
    } else {
      setSelectedGrantData(null);
    }
  };

  const handleDeletGrant = async (gid) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.grant,
        [VIEW_PROFILE_SECTIONS.grant]: {
          gid,
        },
      };
      await deleteUserProfileSectionItem(payload);
      fetchData();
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 ">
            {t("auth.viewProfile.grant")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => toggleGrantModal()}
              >
                <i className="bx bx-plus"></i>{" "}
                {t("auth.viewProfile.addGrantAndFunding")}
              </button>
            </div>
          )}
        </div>

        <ul className="exp-highlight-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-1">
          {grantList && grantList.length > 0 ? (
            grantList.map((grnt, idx) => (
              <li key={idx.toString()}>
                <div className="d-flex gap-3 py-4">
                  <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                    <img
                      src="/assets/images/placeholder.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column gap-1 w-100">
                    <div className="d-flex gap-3">
                      <h5 className="mb-0 text-base font-semibold text-grey-800">
                        {grnt.title}
                      </h5>
                      {isCurrentUserProfile && (
                        <div className="ms-auto d-flex align-items-center gap-3">
                          <Button
                            variant="link"
                            className="p-0 text-base text-grey-600 text-decoration-none"
                            onClick={() => toggleGrantModal(grnt)}
                          >
                            <i className="bx bx-pencil"></i>
                          </Button>
                          <Button
                            variant="link"
                            className="p-0 text-base text-grey-600 text-decoration-none"
                            onClick={() => handleDeletGrant(grnt.gid)}
                          >
                            <i className="bx bx-trash"></i>
                          </Button>
                        </div>
                      )}
                    </div>
                    <span>
                      {grnt.role === "Other" ? grnt.otherGrantRole : grnt.role}
                    </span>
                    <span>
                      {t("common.label.fundingAgency")}: {grnt.fundingAgency}
                    </span>
                    <span>Amount: {grnt.totalAmountAwarded}</span>
                    <span>
                      {grnt.grantStartDate &&
                        formatMonthYear(grnt.grantStartDate)}
                      {" - "}{" "}
                      {grnt.grantEndDate && formatMonthYear(grnt.grantEndDate)}
                    </span>
                    <span>{grnt.description}</span>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">
                  {t("auth.viewProfile.noGrantAndFunding")}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {grantModal && (
        <GrantModal
          show={grantModal}
          grantData={selectedGrantData}
          toggle={toggleGrantModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
